<template>
  <footer class="main-footer" align="center">
    <br>
      <b class="cor-preta">Todos os direitos reservados.</b><br />
      <b class="cor-preta"
        >&copy; 2025
        <a target="”_blank”" href="https://www.panterafood.com.br"
          >Pantera Food</a
        >.</b
      ><br />
      <img
        width="100"
        src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg"
      />
    </footer>
</template>
<script>
export default {

}
</script>

<style>
 footer {
  margin-bottom: 2em;
 }
</style>
